import { PHONE, locationSchema } from "../structured-data-core";

export function getNashvilleStructuredData() {
  const url = "https://restorehair.com/locations/tennessee/nashville/";
  const description =
    "Find out about your hair transplant options in Nashville with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Nashville", "3200 West End Ave, Suite 500", "Nashville", "TN", PHONE, url, description),
  ];
}
